export const TitlePage = ({ title }) => {
  return (
    <p className=" my-4 font-sans-bold text-[28px]"> { title } </p>
  )
}

export const TitleTab = ({ title }) => {
  return (
    <p className=" my-4 font-roboto-bold text-[18px]"> { title } </p>
  )
}

export const SubTitleTab = ({ title }) => {
  return (
    <p className="font-roboto-medium text-[16px]"> { title } </p>
  )
}

export const TitleTabSemiBold = ({ title }) => {
  <div className='font-roboto font-semibold text-lg text-black-100' >
    {title}
  </div>
}